import React, { Component } from 'react';
import InputFloating from '../../../../commons/InputFloating';
import ExpDropSelector from '../../../../commons/ExpDropSelector';
import MobLoader from '../../../../commons/MobLoader';
import ErrorBox from '../../../../commons/ErrorBox';
import ImageUploader from '../../../../commons/ImageUploader';
import CircularProgress from '@material-ui/core/CircularProgress';
import { sendEventToHevo } from '../../../../utilities/manageEvents.js';
import InwardingApiHandlerTest from './../../InwardingApiHandlerTest.js';
import info from './../../../../assets/img/info-button.png';
import Collapse from '@material-ui/core/Collapse';
import ListingProductTest from './ListingProductTest';
import CreateNewListing from './CreateNewListing';
import { Dialog } from '@material-ui/core';

export default class AddNewFreebieTest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loading1: false,
            error: '',
            packType: '',
            productTitle: '',
            imagesUrl: {},
            measurementUnit: 'GRAM',
            grammage: '',
            mrp: '',
            barcodeAvailable: '',
            labelCode: '',
            productsFromTitle: '',
            packTypes: ["BAG", "BALL", "BASKET", "BOTTLE", "BOX", "BUCKET", "CAN", "CARTON", "COMBO_PACK", "CONE", "CUP", "GLASS_BOTTLE", "GLASS_JAR", "JAR", "LOOSE", "PACK", "PET_BOTTLE", "PET_JAR", "POUCH", "PUMP", "REFILL_PACK", "ROLL_ON", "SACHET", "SHEET", "SPOUT_POUCH", "STANDUP_POUCH", "STRIP", "TETRA_BRICK", "TETRA_PACK", "TETRA_PACK_POUCH", "TIN", "TRAY", "TUB", "TUBE", "VACUUM_PACK"],
            unitTypes: ["GRAM", "KILOGRAM", "LITRE", "MILLILITRE", "PIECES"],
            vinv: props.location.state.vinv,
            palletId: props.location.state.palletId,
            parentListingId: props.location.state.parentListingId,
            parentListingTitle: props.location.state.parentListingTitle,
            fromRtv: props.location.state.fromRtv,
            restDetailsNotRequired: false,
            rtvJpin: null,
            rtvListings: [],
            rtvListingId: '',
            createNewListingBox: false,
            productClicked: false
        }
    }

    getHeader = () => {
        return (
            <div className="header-name-bar" style={{ left: '0' }}>
                <div className="row">
                    <div className="col-xs-1">
                        <div className="visible-xs visible-sm" style={{ lineHeight: '65px', fontSize: '25px' }} onClick={() => { this.props.history.goBack(); }}><i className="fas fa-arrow-left"></i></div>
                    </div>
                    <div className="col-xs-11">
                        <div className="header-page-name">Add New Product</div>
                    </div>
                </div>
            </div>
        )
    }

    sendEvent = (eventName, eventData) => {
        const { parentListingId, vinv, palletId } = this.state;
        if (!eventName || !eventData) {
            console.error('data not received');
            return;
        }
        let req = { ...eventData };
        req["parent_listing_id"] = parentListingId ? parentListingId : null;
        req["inwarding_session_id"] = vinv;
        req["gric"] = palletId;
        sendEventToHevo(eventName, req);
    }

    setNameToValue = (e) => {
        const name = e.target.name;
        let val = e.target.value;

        const tar = ['mrp', 'labelCode'];
        if (tar.includes(name) && Number(val) < 0) {
            val = 0;
        }

        this.setState({
            [name]: val
        })
    }

    handleImageUploadResponse = (resp, type) => {
        let imagesUrl = { ...this.state.imagesUrl };
        imagesUrl[type] = resp;
        this.setState({ imagesUrl: imagesUrl });
    }

    addNewProductValidation = () => {
        const { productTitle, packType, barcodeAvailable, grammage, mrp, imagesUrl, labelCode, restDetailsNotRequired } = this.state;

        if (restDetailsNotRequired) {
            //from rtv flow, if catalogued item is selected 
            return false;
        }

        if (productTitle && productTitle.length > 0 &&
            packType &&
            ((barcodeAvailable === 'no') || (barcodeAvailable === 'yes' && labelCode && imagesUrl.capturedLabelCodeImageUrl)) &&
            grammage && Number(grammage) > 0 &&
            mrp && Number(mrp) > 0 &&
            (imagesUrl.capturedFrontSideImageUrl && imagesUrl.backSideImageURL && imagesUrl.grammageImageURL && imagesUrl.mrpImageURL)
        ) {
            return true;
        }

        return false;
    }

    addFreebieButtonClicked = () => {
        const { productTitle, packType, grammage, measurementUnit, mrp, imagesUrl, labelCode, restDetailsNotRequired, fromRtv, rtvJpin } = this.state;
        let state = {};

        state.mrp = Number(mrp);
        state.productTitle = productTitle;
        state.grammage = Number(grammage);
        state.measurementUnit = measurementUnit;

        state.packType = packType;

        state.labelCode = labelCode ? labelCode : null;
        state.labelCodeMatchStatus = "NOT_IN_PO";
        state.capturedLabelCodeImageUrl = imagesUrl.capturedLabelCodeImageUrl ? imagesUrl.capturedLabelCodeImageUrl : null;

        state.capturedFrontSideImageUrl = imagesUrl.capturedFrontSideImageUrl;
        state.backSideImageURL = imagesUrl.backSideImageURL;
        state.grammageImageURL = imagesUrl.grammageImageURL;
        state.mrpImageURL = imagesUrl.mrpImageURL;

        if (!fromRtv) {
            this.sendEvent('ON_CLICK_ADD_NEW_FREEBIE', {
                mrp: Number(mrp),
                product_title: productTitle,
                grammage: Number(grammage),
                measurement_unit: measurementUnit,
                pack_type: packType,
                front_side_image_url: imagesUrl.capturedFrontSideImageUrl,
                back_side_image_url: imagesUrl.backSideImageURL,
                grammage_image_url: imagesUrl.grammageImageURL,
                mrp_image_url: imagesUrl.mrpImageURL,
                barcode_image: imagesUrl.capturedLabelCodeImageUrl,
                barcode: labelCode
            });
        }

        this.props.history.push({
            pathname: '/Inwarding/FreebieDetails',
            state: {
                //its not freebieType, its like product which can be of type of freebie OR rtv
                freebieType: fromRtv ? (restDetailsNotRequired ? 'rtv_catalogued' : 'rtv_non_catalogued') : 'new',
                freebieJpin: rtvJpin,
                vinv: this.state.vinv,
                palletId: this.state.palletId,
                parentListingId: this.state.parentListingId,
                parentListingTitle: this.state.parentListingTitle,
                rtvListingId: this.state.rtvListingId,
                data: state
            }
        });
    }

    // for title change event, reset the image else there is no way to remove them
    searchProductFromTitle = (title) => {

        const { imagesUrl } = this.state;
        imagesUrl.capturedFrontSideImageUrl = '';

        this.setState({ loading1: true, productTitle: title, imagesUrl: imagesUrl, rtvJpin: null });
        InwardingApiHandlerTest.searchProductFromTitle(title)
            .then(data => {
                this.setState({ productsFromTitle: data.productSearchResponseList, showProducts: true, restDetailsNotRequired: false });
            }).catch(error => {
                this.setState({ error: error.error.error });
            }).finally(() => {
                this.setState({ loading1: false })
            })
    }

    inputTitleChanged = (e, num) => {
        const { fromRtv } = this.state;
        let title = e.target.value;


        if (fromRtv && title) {
            /**
             * call product search api if we come from RTV flow 
             * Also, the title should not be '' else api will fail with 500
             */
            this.searchProductFromTitle(title);
        }
        else {
            /**
             * normal text input if we come from Freebie flow 
             */
            this.setState({ productTitle: title });
        }
    }

    setListingDataAndShowIt = (response) => {
        let x = false, y = false;
        if (response) {
            let listings = response.listingInformations;
            if (listings && listings.length > 0) {
                listings.forEach((i, index) => {
                    i['productInfoResponse'] = response.productInfoResponse;
                    if (i.status === "INACTIVE") {
                        y = true;
                    }
                    else {
                        //active, onboarding
                        x = true;
                    }
                })
            }
            this.setState({ rtvListings: listings, atleastOneActive: x, atleastOneInactive: y });
        }
    }

    findListingsForJpin = (jpin) => {
        const { vinv } = this.state;

        if (jpin) {
            this.setState({ loading2: true });
            InwardingApiHandlerTest.callFreebielistingApi(jpin, vinv)
                .then(resp => {
                    if (resp) {
                        this.setListingDataAndShowIt(resp);
                    }
                }).catch(error => {
                    this.setState({ error: error.error.error });
                })
                .finally(e => {
                    this.setState({ loading2: false });
                })
        }
        else {
            //throw error
            this.setState({ error: 'This product has no jpin!' });
        }
    }

    // when user selects a product from the search api response list
    onProductClick = (product) => {
        //this image is used to show in thecounting screen
        const { imagesUrl } = this.state;
        imagesUrl.capturedFrontSideImageUrl = product.imageUrl;

        this.findListingsForJpin(product.jpin);
        this.setState({ productTitle: product.title, showProducts: false, restDetailsNotRequired: true, imagesUrl: imagesUrl, rtvJpin: product.jpin, productClicked: true })
    }

    productSearchUI = (num) => {
        const { productTitle, productsFromTitle, loading1, showProducts } = this.state;
        return (
            <div className="top-ten">
                <div style={{ fontSize: '15px', color: 'rgb(128, 128, 128)' }}>Search/Type Product here:</div>
                <InputFloating type="text" name="productTitle" value={productTitle} onChange={(e) => { this.inputTitleChanged(e, num); this.setState({ productClicked: false }) }} />

                {/* below section is displayed if are coming from rtv flow (check this.inputTitleChanged) 
                    'loading1' only changes in rtv flow  
                */}
                {loading1 ?
                    <div className="product-search-dropdown" style={{ display: 'block', textAlign: 'center', padding: '10px', height: '50px' }} >
                        <CircularProgress style={{ color: '#000' }} size={23} thickness={3} />
                    </div>
                    :
                    <React.Fragment>
                        {(productsFromTitle.length > 0 && showProducts) ?
                            <ul className="product-search-dropdown" style={{ display: 'block' }} >
                                {productsFromTitle.map((product) => {
                                    return (
                                        <li className={"dropdown-data-rec"} key={product.jpin} onClick={() => { this.onProductClick(product) }}>
                                            <div className="dropdown-data-rec-inner">
                                                <div className="row">
                                                    <div className="col-xs-3" style={{ textAlign: 'center' }}>
                                                        <img src={product.imageUrl} style={{ maxWidth: '100%', maxHeight: '40px' }} alt="product" />
                                                    </div>
                                                    <div className="col-xs-9">
                                                        {product.title}
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                            :
                            null
                        }
                    </React.Fragment>
                }
            </div>
        )
    }

    goToCountingScreen = (product) => {
        //set listing id and then go to counting screen
        this.setState({ rtvListingId: product.listingId }, () => {
            this.addFreebieButtonClicked();
        })
    }

    productListingsUI = () => {
        const { rtvListings, atleastOneActive, atleastOneInactive, inactiveOpen } = this.state;

        return (
            <div style={{ maxHeight: '330px', overflow: 'scroll', padding: '5px', border: '1px solid #c2c2c2', marginTop: '10px' }}>
                {(rtvListings.length > 0) ?
                    <React.Fragment>
                        {/* display active listings */}
                        {atleastOneActive ?
                            <div style={{ width: '100%', padding: '15px 10px', fontSize: '15px', backgroundColor: '#fbfffb' }}>Choose from below <span style={{ color: '#03aa03' }}>Active</span> Listings</div>
                            :
                            null
                        }
                        <div>
                            {rtvListings.map((a, index) => {
                                if (a.status !== "INACTIVE") {
                                    return <div key={index} style={{ border: '1px solid #e4e4e4', borderRadius: '5px' }}><ListingProductTest product={a} showQty={false} onClick={() => { this.goToCountingScreen(a) }} /></div>;
                                }
                                else {
                                    return null;
                                }
                            })}
                        </div>

                        {/* display inactive listings in collapsable form */}
                        {atleastOneInactive ?
                            <div style={{ width: '100%', padding: '15px 10px', fontSize: '15px', marginTop: '20px', backgroundColor: 'snow' }} onClick={() => { this.setState({ inactiveOpen: !inactiveOpen }) }}>Choose from below <span style={{ color: '#aa0303' }}>Inactive</span> Listings {inactiveOpen ? <i className="fas fa-chevron-up" style={{ marginLeft: '5px' }}></i> : <i className="fas fa-chevron-down" style={{ marginLeft: '5px' }}></i>}</div>
                            :
                            null
                        }
                        <Collapse in={inactiveOpen}>
                            <div>
                                {rtvListings.map((a, index) => {
                                    if (a.status === "INACTIVE") {
                                        return <div key={index} style={{ border: '1px solid #e4e4e4', borderRadius: '5px' }}><ListingProductTest product={a} showQty={false} onClick={() => { this.goToCountingScreen(a) }} /></div>;
                                    }
                                    else {
                                        return null;
                                    }
                                })}
                            </div>
                        </Collapse>
                    </React.Fragment>
                    :
                    <div style={{ padding: '50px 30px', color: '#BD2E23', display: 'flex', alignItems: 'center' }}>
                        <img src={info} style={{ height: '21px', marginRight: '10px' }} alt='Img' />
                        <div>No Listings available</div>
                    </div>
                }

                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <button className="btn btn-jt-green" onClick={() => { this.setState({ createNewListingBox: true }) }}>Create New Listing</button>
                </div>

            </div>
        )
    }

    newListingCreated = (listing) => {
        let o = listing.listingInformation;
        o.status = "ACTIVE";
        o.productInfoResponse = listing.productInfoResponse;
        o.new = true;
        let all = this.state.rtvListings;
        all.unshift(o);
        this.setState({ rtvListings: all, createNewListingBox: false });
    }

    addNewFreebieUI = () => {
        const { packType, imagesUrl, mrp, measurementUnit, grammage, barcodeAvailable, labelCode, packTypes, unitTypes, restDetailsNotRequired, fromRtv, createNewListingBox, productClicked, rtvJpin, vinv } = this.state;

        return (
            <div>

                {this.productSearchUI()}

                {productClicked ?
                    <div>
                        {this.productListingsUI()}
                    </div>
                    :
                    null
                }


                <Dialog open={createNewListingBox} maxWidth="lg" fullWidth={true} onClose={() => { this.setState({ createNewListingBox: false }) }} classes={{ 'paper': 'tw-margn-class' }}>
                    <CreateNewListing jpin={rtvJpin} vinv={vinv} newListingCreated={this.newListingCreated} />
                </Dialog>

                {!restDetailsNotRequired ?
                    <React.Fragment>
                        <div className="top-twenty">
                            <ExpDropSelector options={packTypes} selected={packType} classes={{ drop: 'invoice-type-drop' }} selctionChange={(val) => { this.setState({ packType: val }) }} type={'Pack Type'} />
                        </div>
                        <div className="top-twenty">
                            <div style={{ fontSize: '15px', color: '#808080' }}>Barcode Available?</div>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '15px' }}>
                                <div style={{ display: 'flex', alignItems: 'flex-start', width: '45%' }}>
                                    <input type="radio" name="barcodeAvailable" id='barcode1' value='yes' onChange={this.setNameToValue} style={{ marginRight: '5px', visibility: 'hidden' }} />
                                    <label htmlFor='barcode1' className={'btn ' + (barcodeAvailable === 'yes' ? 'search-btn-blue' : 'btn-jt-cancel-gr')} style={{ width: '100%', padding: '10px 16px' }} >Yes</label>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', width: '45%' }}>
                                    <input type="radio" name="barcodeAvailable" id='barcode2' value='no' onChange={this.setNameToValue} style={{ marginRight: '5px', visibility: 'hidden' }} />
                                    <label htmlFor='barcode2' className={'btn ' + (barcodeAvailable === 'no' ? 'search-btn-blue' : 'btn-jt-cancel-gr')} style={{ width: '100%', padding: '10px 16px' }}>No</label>
                                </div>
                            </div>
                        </div>

                        {(barcodeAvailable === 'yes') ?
                            <div style={{ margin: '20px 40px 0px 40px' }}>
                                <InputFloating type="number" label="Barcode Number" name="labelCode" value={labelCode} onChange={this.setNameToValue} />
                                <div className="top-ten">
                                    <div className="image-up-not">Barcode Image</div>
                                    {(imagesUrl.capturedLabelCodeImageUrl) ?
                                        <div><img src={imagesUrl.capturedLabelCodeImageUrl} alt="Product front" style={{ maxWidth: '100%' }} /></div>
                                        :
                                        <div><ImageUploader url="inwarding/upload" type="capturedLabelCodeImageUrl" handleUploadResponse={this.handleImageUploadResponse} /></div>
                                    }
                                </div>
                            </div>
                            :
                            null
                        }

                        <div className="top-twenty" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <div style={{ width: '50%' }}><InputFloating type="number" label="Grammage" value={grammage} name='grammage' onChange={this.setNameToValue} /></div>
                            <div style={{ width: '50%' }}><ExpDropSelector type={'Unit'} options={unitTypes} selected={measurementUnit} classes={{ drop: 'invoice-type-drop' }} selctionChange={(val) => { this.setState({ measurementUnit: val }) }} /></div>
                        </div>

                        <div className="top-twenty justCent">
                            <div className="symbolBox" style={{ width: '15%' }}>₹</div>
                            <div style={{ width: '85%' }}><InputFloating type="number" label="MRP" name="mrp" value={mrp} onChange={this.setNameToValue} /></div>
                        </div>

                        <div className="top-twenty">
                            <div className="image-up-not">Front Image</div>
                            {(imagesUrl.capturedFrontSideImageUrl) ?
                                <div><img src={imagesUrl.capturedFrontSideImageUrl} alt="Product front" style={{ maxWidth: '100%' }} /></div>
                                :
                                <div><ImageUploader url="inwarding/upload" type="capturedFrontSideImageUrl" handleUploadResponse={this.handleImageUploadResponse} /></div>
                            }
                        </div>

                        <div className="top-twenty">
                            <div className="image-up-not">Back Image</div>
                            {(imagesUrl.backSideImageURL) ?
                                <div><img src={imagesUrl.backSideImageURL} alt="Product front" style={{ maxWidth: '100%' }} /></div>
                                :
                                <div><ImageUploader url="inwarding/upload" type="backSideImageURL" handleUploadResponse={this.handleImageUploadResponse} /></div>
                            }
                        </div>

                        <div className="top-twenty">
                            <div className="image-up-not">Grammage Image</div>
                            {(imagesUrl.grammageImageURL) ?
                                <div><img src={imagesUrl.grammageImageURL} alt="Product front" style={{ maxWidth: '100%' }} /></div>
                                :
                                <div><ImageUploader url="inwarding/upload" type="grammageImageURL" handleUploadResponse={this.handleImageUploadResponse} /></div>
                            }
                        </div>

                        <div className="top-twenty">
                            <div className="image-up-not">MRP Image</div>
                            {(imagesUrl.mrpImageURL) ?
                                <div><img src={imagesUrl.mrpImageURL} alt="Product front" style={{ maxWidth: '100%' }} /></div>
                                :
                                <div><ImageUploader url="inwarding/upload" type="mrpImageURL" handleUploadResponse={this.handleImageUploadResponse} /></div>
                            }
                        </div>
                    </React.Fragment>
                    :
                    null
                }

                {(this.addNewProductValidation()) ?
                    <div className="bottom-btn" style={{ left: '0', right: '0' }}>
                        <button className="btn btn-big-fin" onClick={this.addFreebieButtonClicked}>
                            {(fromRtv && restDetailsNotRequired) ?
                                <span>Proceed to counting</span>
                                :
                                <span>Add New Product</span>
                            }
                        </button>
                    </div> : null
                }
            </div>
        )
    }

    closeError = () => {
        // close error dialog box
        this.setState({ error: '' });
    }

    render() {
        const { loading, error } = this.state;
        return (
            <div style={{ backgroundColor: 'white', padding: '10px', margin: '10px' }} >

                <div className="visible-xs visible-sm">
                    {this.getHeader()}
                </div>

                {this.addNewFreebieUI()}

                {(loading) ? <MobLoader /> : null}
                {(error) ? <ErrorBox errorText={error} closeError={this.closeError} /> : null}

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/InwardingTest/ComponentsTest/CommonsTest/AddNewFreebieTest.js